import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"รับรองสำเนาถูกต้อง (Certified True Copy) โดย Notarial Attorney","metaTitle":"Certified True Copy รับรองสำเนา 300 บาท/ฉบับ | NYC","metaDesc":"รับรองสำเนาถูกต้อง (Certified True Copy) โดยทนายผู้ทำคำรับรอง ใช้ยื่นวีซ่า สถานทูต ธนาคารต่างประเทศ MFA — ทีมงานตอบไวทุกวัน ปรึกษาก่อนตัดสินใจได้ฟรี"},"en":{"h1":"Certified True Copy — Notarial Attestation of Original Documents","metaTitle":"Certified True Copy Thailand — Notary THB 300/copy | NYC","metaDesc":"Certified True Copy by Notarial Services Attorney at per document. For visas, embassies, foreign bank — Talk to a specialist today; no obligation, fast reply."}} as const;

export const Route = createFileRoute("/en/notary/certified-true-copy")({
  head: () => {
    const url = `${SEO_SITE}/en/notary/certified-true-copy`;
    const c = meta.en;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/en/notary/certified-true-copy", "en")},
        { name: "description", content: ctaDesc(c.metaDesc, "/en/notary/certified-true-copy", "en")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/en/notary/certified-true-copy", "en")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/en/notary/certified-true-copy", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/notary/certified-true-copy", "/en/notary/certified-true-copy")],
    };
  },
  component: () => <SubServicePage slug="notary/certified-true-copy" locale="en" />,
});
